import { forwardRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalDefaultProps } from 'components/Modal';
import { ModalTemplate } from 'components/ModalTemplate';
import { Button } from 'components/buttons';
import { MyCurrencyItems } from './MyCurrencyItems';
import { ModalsContext, ModalType } from 'contexts/modal';

import { ScMyCurrencies } from './styled';

export const MyCurrencies = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const { t } = useTranslation(['deposits', 'glossary']);
    const { handleModal } = useContext(ModalsContext);

    return (
      <ModalTemplate
        ref={ref}
        onClose={onClose}
        title={t('deposits:editCurrency.myCurrencies')}
        settings={{
          type: 'mobile',
          mode: {
            type: 'bottom',
          },
          smallXPadding: true,
        }}
      >
        <ScMyCurrencies>
          <MyCurrencyItems onClose={onClose} />
          <Button
            xLarge
            whiteTransparent
            wide
            onClick={handleModal(ModalType.EditCurrencies, {
              stayInSameWindow: true,
            })}
          >
            {t('glossary:edit')}
          </Button>
        </ScMyCurrencies>
      </ModalTemplate>
    );
  }
);
